import { TabPanel, Text } from '@chakra-ui/react';
import React from 'react';

const Dashboard = () => {
    return (
        <TabPanel>
            <Text>Dashboard</Text>
        </TabPanel>
    );
};

export default Dashboard;